import { Stack, Typography } from '@mui/material';
import Link from '@mui/material/Link';
import { CandidateBatchGroup } from 'generated-graphql/types';
import { useDrawer } from 'services/drawer/hooks';
import { DrawerComponentType } from 'services/drawer/types';

type Props = {
  candidateBatchGroup:
    | Pick<CandidateBatchGroup, 'id' | 'name'>
    | null
    | undefined;
};

export const RulesetLink = ({ candidateBatchGroup }: Props) => {
  const { openDrawer } = useDrawer();

  if (!candidateBatchGroup) return null;

  return (
    <Stack direction="row" gap="4px">
      <Link
        onClick={() => {
          openDrawer({
            drawerContentType: DrawerComponentType.CandidateRankingGroupEdit,
            drawerComponentProps: {
              candidateBatchGroup,
              hideCloseIconButton: true
            }
          });
        }}
        href="javascript:void(0)"
      >
        {candidateBatchGroup.name}
      </Link>
      <Typography>ruleset applied</Typography>
    </Stack>
  );
};
